import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "../css/sponsors.css";
import { db } from "../firebaseConfig";
import { collection, getDocs } from "firebase/firestore";
import { useEffect, useState } from "react";
import Navbar from "../components/navbar";

const Sponsors = () => {
  const [sponsorsMarketing, setSponsorsMarketing] = useState([]);
  const [sponsorsMnP, setSponsorsMnP] = useState([]);
  const [sponsorsEvents, setSponsorsEvents] = useState([]);
  const [titleSponsors, setTitleSponsors] = useState([]);

  useEffect(() => {
    let sponsorsArrayMarket = [];
    let sponsorsArrayMnP = [];
    let sponsorsArrayevents = [];
    let titleSponsors = [];
    getDocs(collection(db, "sponsors")).then((querySnapshot) => {
      querySnapshot.forEach((doc) => {
        let sponsor = {
          desc: doc.data().desc,
          imgLink: doc.data().imgLink,
          webLink: doc.data().webLink,
          name: doc.data().name,
          category: doc.data().category,
        };
        if (sponsor.name === "Hero") titleSponsors.push(sponsor);
        else if (sponsor.category === "MnP") sponsorsArrayMnP.push(sponsor);
        else if (sponsor.category === "Events")
          sponsorsArrayevents.push(sponsor);
        else if (sponsor.category === "Marketing")
          sponsorsArrayMarket.push(sponsor);
      });
      setSponsorsMarketing(sponsorsArrayMarket);
      setSponsorsMnP(sponsorsArrayMnP);
      setSponsorsEvents(sponsorsArrayevents);
      setTitleSponsors(titleSponsors);
      console.log(sponsorsArrayMarket);
    });
  }, []);

  return (
    <>
      <Navbar />
      <div className="app__sponsors">
        <div className="sponsors__left">
          <div className="sponsorsBg"></div>
          <h1>Sponsors</h1>
          <p>
            Over the years, Antaragni has built its undisputed image in the
            industry as a result of the invaluable partnerships it has forged.
            We value you, and you value us. That's how we grow together. The
            contributions from these partnerships has always provided
            entertainment galore for our audience, and made everything possible.
            And thus, the potential opportunities we have for you is a testament
            to the purpose we seek to fulfil!
          </p>
        </div>
        <div className="sponsors__right">
          <h1>Marketing</h1>
          <div className="row align-content-center justify-content-center row-cols-lg-3 row-cols-sm-2 row-cols-1 row_sponsors">
            {titleSponsors.map((sponsor) => {
              return (
                <div className="mb-5 col sponsors__imageDiv">
                  <a target="_blank" rel="noreferrer" href={sponsor.webLink}>
                    <LazyLoadImage
                      className="sponsors__img"
                      src={sponsor.imgLink}
                      alt={sponsor.name}
                    />
                    <p className="sponsors__desc">{sponsor.desc}</p>
                  </a>
                </div>
              );
            })}
          </div>
          <div className="row align-content-center justify-content-center row-cols-lg-3 row-cols-sm-2 row-cols-1 row_sponsors">
            {sponsorsMarketing.map((sponsor) => {
              return (
                <div className="mb-5 col sponsors__imageDiv">
                  <a target="_blank" rel="noreferrer" href={sponsor.webLink}>
                    <LazyLoadImage
                      className="sponsors__img"
                      src={sponsor.imgLink}
                      alt={sponsor.name}
                    />
                    <p className="sponsors__desc">{sponsor.desc}</p>
                  </a>
                </div>
              );
            })}
          </div>

          <h1>Media</h1>
          <div className="row align-content-center justify-content-center row-cols-lg-3 row-cols-sm-2 row-cols-1 row_sponsors">
            {sponsorsMnP.map((sponsor) => {
              return (
                <div className="mb-5 col sponsors__imageDiv">
                  <a target="_blank" rel="noreferrer" href={sponsor.webLink}>
                    <LazyLoadImage
                      className="sponsors__img"
                      src={sponsor.imgLink}
                      alt={sponsor.name}
                    />
                    <p className="sponsors__desc">{sponsor.desc}</p>
                  </a>
                </div>
              );
            })}
          </div>
          <h1>Events</h1>
          <div className="row align-content-center justify-content-center row-cols-lg-3 row-cols-sm-2 row-cols-1 row_sponsors">
            {sponsorsEvents.map((sponsor) => {
              return (
                <div className="mb-5 col sponsors__imageDiv">
                  <a target="_blank" rel="noreferrer" href={sponsor.webLink}>
                    <LazyLoadImage
                      className="sponsors__img"
                      src={sponsor.imgLink}
                      alt={sponsor.name}
                    />
                    <p className="sponsors__desc">{sponsor.desc}</p>
                  </a>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default Sponsors;
